import React from 'react';
import { volumes } from '../data/coachSystem';
import { CtaButton } from './CtaButton';
export function VolumesSection() {
  return <section className="border-y border-navy-line bg-ivory py-11 sm:py-14" aria-labelledby="volumes-title" data-id="element-113" data-mp="3utm3io1d8bv3">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-114" data-mp="cm51sq12mfl0">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-115" data-mp="7nbmcs284ei7">
          The complete Volleyball Coach System™
        </p>
        <h2 id="volumes-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-116" data-mp="3c4fhos59z452">
          6 professional volumes.
          <span className="mt-1 block text-navy-muted" data-id="element-117" data-mp="3l42j3dy089y4">
            One connected coaching system.
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-118" data-mp="2xd5i2w7qyx1n">
          Instead of collecting more random drills, you get one organized system
          you can return to throughout the season — from practice planning and
          player development to team systems and season organization.
        </p>

        <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-119" data-mp="2j5bnnn1qa75u">
          {volumes.map(volume => <li key={volume.number} className="relative flex h-full flex-col items-center overflow-hidden rounded-xl border border-navy-edge bg-white p-4 pt-4 text-center shadow-panel sm:p-5" data-id="element-120" data-mp="2o4wpq6c72vms">
              <span className="pointer-events-none absolute -top-2 left-1/2 -translate-x-1/2 select-none font-display text-[3.4rem] font-semibold leading-none text-teal/[0.07] sm:text-[4.2rem]" aria-hidden="true" data-id="element-121" data-mp="1vg96shex4ice">
                {volume.number}
              </span>

              <p className="relative text-[0.55rem] font-bold uppercase tracking-[0.2em] text-teal sm:text-[0.6rem]" data-id="element-122" data-mp="3bw22gcmu97sv">
                Volume {String(volume.number).padStart(2, '0')}
              </p>
              <p className="relative mt-1 text-[0.55rem] font-semibold uppercase tracking-[0.16em] text-sand sm:text-[0.6rem]" data-id="element-123" data-mp="1gsxckaod8nf1">
                {volume.stage}
              </p>

              <span className="mt-2.5 block h-px w-7 bg-teal-mid" aria-hidden="true" data-id="element-124" data-mp="1pqz6y7dlghtc" />

              <h3 className="mt-2.5 font-display text-[0.95rem] font-medium leading-snug tracking-tight text-navy sm:text-[1.08rem]" data-id="element-125" data-mp="1kqlc5r1074d9">
                {volume.title}
              </h3>
              <p className="mt-2 text-[0.78rem] leading-relaxed text-navy-muted sm:text-[0.86rem]" data-id="element-126" data-mp="sz5duzq33t77">
                {volume.benefit}
              </p>
            </li>)}
        </ol>

        <div className="mt-6 flex flex-col items-center gap-4" data-id="element-127" data-mp="120lqle4dg7el">
          <p className="mx-auto max-w-xl text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-128" data-mp="ebajzg0cbisj">
            Together, the six volumes take you from practice planning → drills →
            player development → team systems → complete practices → season
            planning — without building your coaching system from zero.
          </p>
          <CtaButton label="Get the complete system" variant="teal" className="sm:w-auto" data-id="element-129" data-mp="2psm7jhcxl48i" />
        </div>
      </div>
    </section>;
}